import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DIALOG_HIDE_CLASS } from '../../shared/constants';
import { ILotEdit } from '../../ranch-settings/modals/lot/interfaces';
import { RanchLotFormComponent } from '../../ranch-settings/shared/ranch-lot-form/ranch-lot-form';

@Component({
	moduleId: module.id,
	selector: 'ranch-create-planting-area-dialog',
	templateUrl: 'planting-area-dialog.html'
})

export class RanchCreatePlantingAreaDialog implements OnDestroy {
	@ViewChild(RanchLotFormComponent, { static: false })
	public lotForm: RanchLotFormComponent;

	private _subscriptions$: Subject<boolean>;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { lot?: ILotEdit, ranchCoordinates: string },
		private _dialogRef: MatDialogRef<RanchCreatePlantingAreaDialog>
	) {
		this._subscriptions$ = new Subject();

		this._dialogRef.backdropClick()
			.pipe(takeUntil(this._subscriptions$)).subscribe((e: MouseEvent) => {
				this.close();
			});
	}

	ngOnDestroy(): void {
		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public close(): void {
		if (!this.lotForm) {
			this._closeFinal();
			return;
		}

		this.lotForm.cancel();
	}

	public hide(): void {
		this._dialogRef.addPanelClass(DIALOG_HIDE_CLASS);
	}

	public show(): void {
		this._dialogRef.removePanelClass(DIALOG_HIDE_CLASS);
	}

	public submit(lot: ILotEdit): void {
		this._dialogRef.close(lot);
	}

	private _closeFinal(): void {
		this._dialogRef.close();
	}
}
